import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconEnlargeActiveSvg } from "./IconEnlargeActiveSvg.mjs";
import { IconEnlargeSvg } from "./IconEnlargeSvg.mjs";
const IconEnlarge = ({ active = false, ...props }) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(
  Box,
  {
    component: active ? IconEnlargeActiveSvg : IconEnlargeSvg,
    ...svgProps
  }
) });
export {
  IconEnlarge
};
